import { useState, useEffect, useCallback } from 'react'

export const usePeerService = (peerService) => {
  const [peers, setPeers] = useState([])
  const [bots, setBots] = useState([])

  const refresh = useCallback(async (opts) => {
    if (!peerService) return
    const result = await peerService.discover(opts)
    setPeers(result.peers)
    setBots(result.bots)
  }, [peerService])

  useEffect(() => {
    if (!peerService) return
    refresh()
    const interval = setInterval(() => refresh(), 30000)
    return () => clearInterval(interval)
  }, [peerService, refresh])

  return { peers, bots, refresh }
}
